interface FrogIconProps {
  className?: string;
}

const FrogIcon = ({ className }: FrogIconProps) => (
  <svg
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    role="img"
  >
    {/* Arms raised in dance */}
    <path
      d="M32 58 Q18 50 15 36"
      stroke="#16a34a"
      strokeWidth="6"
      fill="none"
      strokeLinecap="round"
    />
    <path
      d="M68 58 Q82 50 85 36"
      stroke="#16a34a"
      strokeWidth="6"
      fill="none"
      strokeLinecap="round"
    />
    {/* Legs */}
    <path
      d="M38 80 Q30 92 19 90"
      stroke="#16a34a"
      strokeWidth="7"
      fill="none"
      strokeLinecap="round"
    />
    <path
      d="M62 80 Q70 92 81 90"
      stroke="#16a34a"
      strokeWidth="7"
      fill="none"
      strokeLinecap="round"
    />
    {/* Body */}
    <ellipse cx="50" cy="64" rx="23" ry="21" fill="#22c55e" />
    {/* Belly */}
    <ellipse cx="50" cy="70" rx="13" ry="12" fill="#bbf7d0" />
    {/* Head */}
    <ellipse cx="50" cy="44" rx="20" ry="13" fill="#22c55e" />
    {/* Eyes */}
    <circle cx="38" cy="33" r="10" fill="#22c55e" />
    <circle cx="62" cy="33" r="10" fill="#22c55e" />
    <circle cx="38" cy="31" r="6" fill="#fff" />
    <circle cx="62" cy="31" r="6" fill="#fff" />
    <circle cx="39" cy="31" r="2.8" fill="#1c1917" />
    <circle cx="63" cy="31" r="2.8" fill="#1c1917" />
    {/* Smile */}
    <path
      d="M40 46 Q50 54 60 46"
      stroke="#14532d"
      strokeWidth="3"
      fill="none"
      strokeLinecap="round"
    />
  </svg>
);

export default FrogIcon;
